import { useMenu } from "../../../contexts/menu/menu.hook";
import { MenuContentOptions } from "../../../contexts/menu/Menu.types";

export const MenuContentCastCrew = () => {
  const { setMenuContent } = useMenu();

  return (
    <div>
      <p>Cast and crew will go here</p>
      <button onClick={() => setMenuContent(MenuContentOptions.NAVIGATION)}>
        Back to menu
      </button>
    </div>
  );
};
